import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

let webApiUrl = `${process.env.REACT_APP_BASE_URL}weather_3minutes`;
let tokenStr = process.env.REACT_APP_API_TOKEN;

export const fetchWeather = createAsyncThunk("weather/fetchSATA", () => {
  return axios
    .get(webApiUrl, { headers: { Authorization: `Token ${tokenStr}` } })
    .then((response) => response.data);
});
const weatherSlice = createSlice({
  name: "weather",
  initialState: {
    weatherLoading: true,
    weatherData: {
      SATA: [],
    },
    weatherError: "",
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchWeather.pending,
      (state) => {
        state.weatherLoading = true;
      },
      builder.addCase(
        fetchWeather.fulfilled,
        (state, action) => {
          state.weatherLoading = false;
          state.weatherData = action.payload;
          state.weatherError = "";
        },
        builder.addCase(fetchWeather.rejected, (state, action) => {
          state.weatherLoading = false;
          state.weatherData = [];
          state.weatherError = action.error.message;
        })
      )
    );
  },
});
export default weatherSlice.reducer;
